module.exports = __webpack_public_path__ + "323e6045af5935aefb6b2ff7edeaeecd.png";